import { MessagingProvider, ZIMAdapter, UploadProvider } from '@zillow/messaging-core';
import React, { useMemo } from 'react';
import { useGetEnvironmentVariablesQuery } from '../../API/BaseApi';
import { getCorrectBearerJwtForUrl } from '../accessControl/getCorrectBearerJwtForUrl';
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from '@apollo/client';
import { useMyZillowUserData } from 'components/accessControl/hooks/hooks';

export const MessagingWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: envVars } = useGetEnvironmentVariablesQuery();
  const zillowData = useMyZillowUserData();

  const graphqlUrl = envVars?.apiLocation ? `${envVars.apiLocation}/timber/api/internal/zim/graphql` : '';

  // Create Apollo Client with HttpLink (Apollo v3 best practice)
  const client = useMemo(() => {
    if (!graphqlUrl) return null;

    const httpLink = new HttpLink({
      uri: graphqlUrl,
      headers: {
        authorization: `Bearer ${getCorrectBearerJwtForUrl(graphqlUrl)}`,
        'x-z-login-memento': zillowData.memento || '',
      },
    });

    return new ApolloClient({
      link: httpLink,
      cache: new InMemoryCache({
        possibleTypes: {},
      }),
    });
  }, [graphqlUrl, zillowData]);

  const adapter = useMemo(() => {
    if (!client) return null;

    return new ZIMAdapter({
      client: client as any,
    });
  }, [client]);

  if (!client || !adapter) {
    return <div>Loading messaging...</div>;
  }

  return (
    <ApolloProvider client={client}>
      <MessagingProvider adapter={adapter}>
        <UploadProvider>{children}</UploadProvider>
      </MessagingProvider>
    </ApolloProvider>
  );
};
